import React, { Component } from 'react';
import PatientData from './PatientData/PatientData';
import Loader from '../../../components/UI/Loader/Loader';

import { connect } from 'react-redux';
import { fetchPatients } from './../../../store/actions/patientList.js';
import { Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import s from '../Patients.module.css';

class PatientsList extends Component {
  componentDidMount() {
    this.props.fetchPatients();
  }
  render() {
    return (
      <div className="container-fluid">
        <div className="card mb-3">
          <div className="card-header">
            <i className="fa fa-table" /> Список зарегистрированных пациентов
            <div className={s.addButton}>
              <NavLink to="/patients-creator">
                <Button type="primary">Добавить пациента</Button>
              </NavLink>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {this.props.loader ? (
                <Loader />
              ) : (
                <table
                  className="table table-sm table-hover table-striped table-bordered"
                  id="dataTable"
                  width="100%"
                  cellSpacing={0}
                >
                  <thead>
                    <tr className="table-active">
                      <th>#</th>
                      <th>ИИН</th>
                      <th>Ф.И.О.</th>
                      <th>Дата поступления</th>
                      <th>Диагноз</th>
                      <th>Степень тяжести</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.patients.map((item, index) => {
                      return (
                        <PatientData
                          key={Math.random()}
                          id={index + 1}
                          IIN={item.IIN}
                          FIO={item.FIO}
                          regDate={item.regDate}
                          diagnosis={item.diagnosis}
                          severity={item.severity}
                        />
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    patients: state.patient.patients,
    loader: state.patient.loader,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchPatients: () => dispatch(fetchPatients()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientsList);
